import { useMemo } from 'react';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';
import { NUMERIC_FIELDS, LETTER_FIELDS, IBAN_FIELDS } from '@/hooks/search/useSearch.types';
import { extractWalletIdFromIBAN } from '@/utils/tools/IBAN/IBANTools';

const numericRegex = /^\d+$/;
const letterRegex = /[a-zA-Z]/;
const emailRegex = /^[-+\w.]+@[^@\s]+\.[^@\s]+/;

export function useSearchMenu({ search }: { search: string }) {
  const dashboardConfig = useDashboardConfig();

  const fields = dashboardConfig.settings.searchBar;

  const searchFields = useMemo(() => {
    return fields.map((field) => {
      let isFieldDisabled = true;

      if (numericRegex.test(search) && NUMERIC_FIELDS.includes(field)) {
        isFieldDisabled = false;
      }

      if (letterRegex.test(search) && LETTER_FIELDS.includes(field)) {
        isFieldDisabled = false;
      }

      if (IBAN_FIELDS.includes(field)) {
        const IBANDetails = extractWalletIdFromIBAN(search);
        if (IBANDetails) {
          if ((IBANDetails.walletId && field === 'walletIban') || field === 'beneficiaryIban') {
            isFieldDisabled = false;
          }
        }
      }

      if (emailRegex.test(search) && field === 'email') {
        isFieldDisabled = false;
      }

      return { value: field, isDisabled: isFieldDisabled };
    });
  }, [fields, search]);

  return { searchFields };
}
